import { render, staticRenderFns } from "./addAccount.vue?vue&type=template&id=81c1295e&scoped=true"
import script from "./addAccount.vue?vue&type=script&lang=js"
export * from "./addAccount.vue?vue&type=script&lang=js"
import style0 from "./addAccount.vue?vue&type=style&index=0&id=81c1295e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c1295e",
  null
  
)

export default component.exports